var _path, _circle, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCredit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4728 7.27711C16.3779 6.51807 15.6189 5.85392 14.765 5.85392C13.8162 5.85392 13.0571 6.42319 13.0571 7.37199C13.0571 8.32078 13.911 8.7003 14.765 8.89006C15.6189 9.07982 16.5677 9.55422 16.5677 10.503C16.5677 11.4518 15.8086 12.0211 14.8598 12.0211M13.152 10.3133C13.152 11.262 13.911 12.0211 14.8598 12.0211M14.8598 12.0211V12.875M14.8598 5.85392V5",
    stroke: "black",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 8.75,
    r: 5.875,
    stroke: "black",
    strokeWidth: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 21.7812C6.25 20.0312 8 19.0312 10.125 19.0312C10.875 19.0312 11.625 19.1562 12.375 19.5312C12.5 19.5312 12.5 19.5312 12.625 19.5312H18.5C19 19.5312 19.5 20.2812 19.5 20.7812C19.5 21.4062 19.125 22.1562 18.5 22.1562H14.25",
    stroke: "black",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 20.4063C22.5 17.4063 23.75 16.5313 23.75 16.5313C24.25 16.1562 25.125 16.1562 25.5 16.5313C25.875 16.9063 25.875 17.7812 25.5 18.2812L20.875 23.7812C20.25 24.4062 19.25 24.7813 18.375 24.7813H11.5C10.875 24.7813 10.25 25.0313 9.75 25.5313L9.375 25.9062",
    stroke: "black",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.125 20.7812L10.5 27.1562",
    stroke: "black",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCredit);
export default __webpack_public_path__ + "static/media/icon-credit.d3252695fe4b25703d6c72689909a789.svg";
export { ForwardRef as ReactComponent };